import {
  V2ListSalesExecutivesForAccountApiArg,
  useV2ListSalesExecutivesForAccountQuery,
} from "@generated";
import type { SalesExecutive } from "../types";

export interface UseSalesExecutivesListArgs {
  page?: V2ListSalesExecutivesForAccountApiArg["page"];
  filter?: V2ListSalesExecutivesForAccountApiArg["filter"];
}

export interface SalesExecutivesListPageMeta {
  recordCount: number;
  pageCount: number;
}

export const useSalesExecutivesList = ({
  page,
  filter,
}: UseSalesExecutivesListArgs) => {
  const { data, error, isLoading, isFetching, refetch } =
    useV2ListSalesExecutivesForAccountQuery(
      { page, filter },
      // Refetch on remount (e.g. returning from Edit) so saves are reflected.
      { refetchOnMountOrArgChange: true }
    );

  const rows: SalesExecutive[] = (data?.data ?? []).map((se) => ({
    id: String(se.id),
    name: se.attributes?.name ?? "",
    phone: se.attributes?.phone,
    email: se.attributes?.email,
    title: se.attributes?.title,
    active: se.attributes?.active,
  }));

  const pageMeta: SalesExecutivesListPageMeta = {
    recordCount: data?.meta?.["record-count"] ?? 0,
    pageCount: data?.meta?.["page-count"] ?? 0,
  };

  return { rows, pageMeta, error, isLoading, isFetching, refetch };
};

export default useSalesExecutivesList;
